import React, { useEffect, useState } from 'react'
import { Box, Grid, IconButton, ListItemIcon, MenuItem, Pagination, Stack, useTheme } from '@mui/material';
import route from '../../../utils/Routes';
import { useNavigate, useSearchParams } from 'react-router-dom';
import ScrollBox from '../../../components/ScrollBox';
import ProductCard from '../../../components/ProductCard';
import SwapVertOutlinedIcon from '@mui/icons-material/SwapVertOutlined';
import SearchTxtField from '../../../components/SearchTxtField';
import BackButton from '../../../components/BackButton';
import { getAmtcProd, getSingleCatServ } from '../../../services/amtc-service';
import { isNotEmpty } from '../../../utils/format';
import { useAuthContext } from '../../../context/AuthContext';
import { useQuery } from 'react-query';
import QueryKey from '../../../utils/QueryKey';
import { customAlert } from '../../../components/notify';
import PathBtns from '../../../components/PathBtns';
import { CreateNewFolder, Edit, MoreVert } from '@mui/icons-material';
import OptionMenu from '../../../components/OptionMenu';
import constants from '../../../utils/Constants';


function AmtcProductListPage() {
    const navigate = useNavigate();
    const theme = useTheme();
    const { setLoadingScreen, ctxtUser } = useAuthContext();
    const limit = 12;
    const [order, setOrder] = useState('desc');
    const [searchParams, setSearchParams] = useSearchParams();
    const qCatId = searchParams.get("catId");
    const qSubCatId = searchParams.get("subCatId");
    const pgNo = parseInt(searchParams.get("pgNo") || "1");
    const querySearchWord = searchParams.get("s") || "";
    const [searchWord, setSearchWord] = useState(decodeURIComponent(querySearchWord) || "");
    const [isSrchBtnClick, setIsSrchBtnClick] = useState(0)
    const isSrchRes = parseInt(searchParams.get("isSrchRes") || "0");

    const { isLoading: isProdLoading, isError: isProdErr, error: prodErr, data: prodData } = useQuery([QueryKey.amtcProd, pgNo, qCatId, qSubCatId, order, isSrchBtnClick],
        () => getAmtcProd({ catId: qCatId, subCatId: qSubCatId, pageNumber: pgNo, searchKeyWord: searchWord, order, limit }), {
        enabled: (isNotEmpty(qCatId) || isNotEmpty(qSubCatId)),
        refetchOnMount: true,
        refetchOnWindowFocus: false,
        keepPreviousData: true
    });

    const { isLoading, isError, error, data: catData } = useQuery([QueryKey.singleCat, qCatId, qSubCatId], () => getSingleCatServ(qCatId || qSubCatId),
        {
            enabled: (isNotEmpty(qCatId) || isNotEmpty(qSubCatId)),
            refetchOnMount: true,
            refetchOnWindowFocus: false,
        })

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const optionItems = [
        {
            title: "Edit Subcategory",
            icon: <Edit fontSize="small" />,
            fn: () => navigate(route.aEditSubcat, { state: { subCatId: qSubCatId } })
        },
        {
            title: "Create Product",
            icon: <CreateNewFolder fontSize="small" />,
            fn: () => navigate(route.aAddproduct, { state: { subCatId: qSubCatId } })
        }
    ]

    const pathBtnsArr = [{
        label: "Category",
        handleClick: () => navigate(route.aCataLog)
    },
    ...(qSubCatId ? [{
        label: catData?.parCatName,
        handleClick: () => navigate(`${route.aSubcategory}/?catId=${catData?.parentId}&catName=${catData?.parCatName}`)
    }, {
        label: catData?.catName,
        handleClick: () => { }
    }] : [{
        label: catData?.catName,
        handleClick: () => { }
    }])]

    useEffect(() => {
        setLoadingScreen(isProdLoading);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isProdLoading]);

    useEffect(() => {
        setLoadingScreen(isLoading);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoading]);

    useEffect(() => {
        if (!qCatId && !qSubCatId) {
            navigate("/", { replace: true });
        }
    }, [qCatId, qSubCatId, navigate]);



    const handleOptionClose = () => {
        setAnchorEl(null);
    };

    const handleOptionClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handlePageChange = async (event, value) => {
        //    setPageNumber(value);
        setSearchParams(prev => {
            prev.set("pgNo", value)
            return prev
        }, { replace: true })
    };

    async function onOrderChange(e) {
        if (order === "desc")
            setOrder("asc");
        else
            setOrder("desc");
        setSearchParams(prev => {
            prev.set("pgNo", 1)
            return prev
        }, { replace: true })
    }

    async function onSearchBtnClick(e) {
        setIsSrchBtnClick((prevVal) => ++prevVal)
        setSearchParams(prev => {
            prev.set("pgNo", 1)
            prev.set("isSrchRes", 1)
            return prev
        }, { replace: true })
    }

    function onSearch(e) {
        setSearchWord(e.target.value)
        setSearchParams(prev => {
            prev.set("s", encodeURIComponent(e.target.value))
            return prev
        }, { replace: true })
    }

    // function handleDDChange(e) {
    //     setSearchParams(prev => {
    //         prev.set("st", e.target.value)
    //         return prev
    //     }, { replace: true })
    // }

    function handleOnClear(e) {
        setIsSrchBtnClick((prevVal) => ++prevVal)
        setSearchWord("");
        setSearchParams(prev => {
            prev.set("pgNo", 1)
            prev.set("s", "")
            prev.set("isSrchRes", 0)
            return prev
        }, { replace: true })
    }



    if (isProdErr) {
        customAlert(prodErr);
        return <h2>Something went wrong</h2>
    }

    if (isError) {
        customAlert(error);
        return <h2>Something went wrong</h2>
    }

    return (<Box height={"100%"} width={"100%"}>
        <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 1, mt: 1 }} width={"100%"}>
            <Stack width={"33%"} direction={"row"} alignItems={"center"} gap={1}>
                <BackButton />
                <PathBtns btnsArr={pathBtnsArr} />
            </Stack>
            <Stack direction={"row"} justifyContent="center" alignItems={"center"} gap={2} width={"33%"} >
                <Box mb={0.5}><SearchTxtField width={400} handleOnClear={handleOnClear} variant={"outlined"} searchKeyWord={searchWord}
                    onSearch={onSearch} onBtnClick={onSearchBtnClick} placeholder={ctxtUser?.isComUser ? `Search Product By Name / AMTC ID / MAT Code / Desc / Manufacturer` : `Search Product By Name / AMTC ID / Desc / Manufacturer`} /></Box>
            </Stack>
            <Stack direction={"row"} justifyContent="end" alignItems={"center"} gap={2} width={"33%"} >
                {isSrchRes === 1 ? <></> : <IconButton onClick={onOrderChange}>
                    <SwapVertOutlinedIcon />
                </IconButton>}
                {ctxtUser?.userType === constants.admin && <IconButton onClick={handleOptionClick} sx={{ color: theme.palette.custom.btn }}  >
                    <MoreVert />
                </IconButton>}
            </Stack>
        </Stack>

        <ScrollBox height={"84%"}>
            <Grid container spacing={3}
                direction="row"
                justifyContent="center"
                alignItems="center"
            >
                {(prodData?.prodsArr ?? []).map((i) => <Grid item xs="auto" key={i.id}>
                    <ProductCard i={i} key={i?.id} isComUser={ctxtUser?.isComUser} /> </Grid>)}
            </Grid>
        </ScrollBox>
        <Stack sx={{ alignItems: "center", mt: 1 }}>
            <Pagination count={Math.ceil(prodData?.totalProdsCount / limit) || 0} color="primary"
                page={pgNo} onChange={handlePageChange} variant="outlined" shape="rounded" />
        </Stack>

        <OptionMenu open={open} handleClose={handleOptionClose} anchorEl={anchorEl} >
            {optionItems.map((i) => <MenuItem
                sx={{ pl: 2, pr: 5, fontSize: 14 }}
                key={i.title}
                onClick={i.fn}>
                <ListItemIcon > {i.icon}</ListItemIcon>
                {i.title}
            </MenuItem>)}
        </OptionMenu>
    </Box>
    )
}
export default AmtcProductListPage;